<template lang="pug">
  #adminaccess
    v-container(fluid)
      LoseAccesDialog(ref="loseAccesModal")
      v-layout(row wrap justify-space-around).mt-5
        v-flex(xs12 sm3).mt-3
          h3.dark-text LISTA DE USUARIOS
          v-layout(row wrap).user-list
            v-flex.user.py-2(xs12 v-if="!userList.length > 0")
              p.field-title.mb-0.ml-1 Aún no hay usuarios registrados
            v-flex.user.py-2(xs12 v-if="userList.length > 0" v-for="user in userList" @click="selectUser(user)" :class="{ 'toggle-user': user.clicked }")
              p.field-title.mb-0.ml-1 {{user.name}}
              p.field-title.bold.mb-0.ml-1 {{user.email}}
            v-layout(row wrap justify-center align-center).mt-2
              v-btn.save.dark-btn.bold.py-1.px-5(@click="addUser()") Nuevo usuario
        v-flex(xs12 sm7).mt-3
          v-layout(d-flex row justify-end align-center v-if="!newUser && currentUser.permission.deleteUser")
            v-flex(xs12)
              p.delete(@click="deleteUser()") Eliminar usuario &nbsp;
                span 
                  font-awesome-icon(icon="trash-alt" size="lg")
          v-layout.profile(row wrap justify-center align-center).my-3
            v-flex(xs12 sm3)
              v-tooltip(light right)
                .edit(slot="activator")
                  font-awesome-icon(icon="times" @click="deleteFoto")
                span Borrar foto
              img(width="100%" v-if="selectedUser.profileImg && selectedUser.profileImg.url" title="Cambiar imagen" fluid alt="profile img" :src="foto"  @click="pickFile")
              img(width="100%" v-if="!(selectedUser.profileImg && selectedUser.profileImg.url)" title="Cambiar imagen" fluid alt="profile img" src="static/upload-icon.png"  @click="pickFile")  
              input(
                type="file"
                style="display: none"
                ref="image"
                accept="image/*"
                @change="uploadUserProfileImg"
              )
            v-flex(xs12 sm9).pl-4
              // Nombre
              h2.field-title.my-1(v-if="!editName" @click="editField('name')") {{selectedUser.name}}
                v-tooltip(light right)
                  .edit(slot="activator")
                    font-awesome-icon(icon="pen")
                  span Editar nombre

              v-form.mb-3(v-if="editName")
                label.label-title(for="userName") Nombre completo:
                v-layout(row flex justify-center)
                  input.access-form-control(name="userName", v-model="selectedUser.name")
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="saveField('name')" slot="activator")
                      font-awesome-icon(icon="save")
                    span Guardar cambios
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="cancelEdit('name')" slot="activator")
                      font-awesome-icon(icon="times")
                    span Cancelar cambios

              // Rol
              h3.field-title.bold.my-1(v-if="!editRole" @click="editField('role')") {{selectedUser.role}}
                v-tooltip(light right)
                  .edit(slot="activator")
                    font-awesome-icon(icon="pen")
                  span Editar rol
                  
              v-form.mt-3(v-if="editRole")
                label.label-title(for="userRole") Tipo de usuario:
                v-layout(row flex justify-center)
                  v-select.select.pt-0(name="userRole", v-model="selectedUser.role" :items="roleOptions" append-outer-icon="map")
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="saveField('role')" slot="activator")
                      font-awesome-icon(icon="save")
                    span Guardar cambios
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="cancelEdit('role')" slot="activator")
                      font-awesome-icon(icon="times")
                    span Cancelar cambios

              // Correo
              p.field-title.bold.my-1(v-if="!editMail" @click="editField('mail')") {{selectedUser.email}}
                v-tooltip(light right)
                  .edit(slot="activator")
                    font-awesome-icon(icon="pen")
                  span Editar correo

              v-form.my-2(v-if="editMail")
                label.label-title(for="userMail") Correo de acceso:
                v-layout(row flex justify-center)
                  input.access-form-control(
                    type="email",
                    required,
                    name="userMail", 
                    v-model="selectedUser.email",
                    value="selectedUser.email")
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="saveField('mail')" slot="activator")
                      font-awesome-icon(icon="save")
                    span Guardar cambios
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="cancelEdit('mail')" slot="activator")
                      font-awesome-icon(icon="times")
                    span Cancelar cambios

              // Contraseña
              p.pswd.dark-text.bold.my-3(@click="editField('password')" v-if="!editPassword") Editar contraseña
              v-form.mt-3(v-if="editPassword")
                v-layout(row flex justify-center align-end)
                  .form-group
                    label.label-title(for="userPaswd") Nueva contraseña:
                    input.access-form-control(
                      type="password" 
                      required,
                      name="userPaswd",
                      v-model="selectedUser.password",
                      value="selectedUser.password"
                    )
                  .form-group.pl-2
                    label.label-title(for="pswConfirm") Confirmar contraseña:
                    input.access-form-control(
                      type="password" 
                      required,
                      name="pswConfirm",
                      v-model="confirmPassword",
                      value="confirmPassword"
                    )
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="updatePassword()" slot="activator")
                      font-awesome-icon(icon="save")
                    span Guardar cambios
                  v-tooltip(light right v-if="!newUser")
                    .edit.ml-2(@click="cancelEdit('password')" slot="activator")
                      font-awesome-icon(icon="times")
                    span Cancelar cambios
                
          hr(v-if="!newUser && this.currentUser.permission.createUser")
          v-layout(row justify-center align-center v-if="!newUser && this.currentUser.permission.createUser").mt-3
            v-flex(xs12).px-4.mt-3
              h4.dark-text PERMISOS:
              // p.access-subtitle Selecciona cuáles variables puede ver el usuario:
          v-layout(row justify-space-between align-center v-if="!newUser && selectedUser.permission")
            v-form 
              v-layout(row wrap align-center)
                v-flex.checkbox-form-group(xs12 md4 v-for="permission in permissionOptions" :key="permission.slug")
                  v-checkbox.form-check-input(:label="permission.name" name="permissionCheckOptions" v-model="selectedUser.permission[permission.slug]" @click="saveField(permission.slug)" )

          v-layout(row justify-end align-center v-if="newUser").mt-3
            v-btn.save.dark-btn.bold.py-1.px-3.my-5(@click="createUser()") Crear usuario
</template>
<script>
/**
 * @todo:
 * 1. Upload img -> selectedUser.profileImg
 * 2. Get permissions and role options from api
 */
import LoseAccesDialog from "./LoseAccesDialog.vue";

export default {
  name: "AdminAccess",
  components: {
    LoseAccesDialog
  },
  data() {
    return {
      permissionOptions: [
        {
          slug: "createUser",
          name: "Crear usuario"
        },
        {
          slug: "deleteUser",
          name: "Eliminar usuario"
        },
        {
          slug: "createReports",
          name: "Crear casos"
        },
        {
          slug: 'viewReports',
          name: "Ver casos",
        },
        {
          slug: 'updateReports',
          name: "Editar casos"
        },
        {
          slug: 'deleteReports',
          name: "Eliminar casos"
        }
      ],
      confirmPassword: "",
      dialog: false,
      editRole: false,
      editName: false,
      editMail: false,
      editPassword: false,
      newUser: false,
      originalUser: {},
      roleOptions: ["Administración", "Capturista", "Visitante"]
    };
  },
  computed: {
    userList() {
      return this.$store.getters.userList;
    },
    currentUser() {
      //console.log(this.$store.state.user)
      return this.$store.state.user;
    },
    foto: {
      get() {
        //console.log('get', this.$store.state.userEdit.profileImg);
        return this.$store.state.userEdit.profileImg.url + "?" + new Date().getTime();
      },
      set(value) {
        this.$store.commit("updateUserProfileImg", value);
      }
    },
    selectedUser() {
      return this.$store.getters.userEdit;
    },
    userPassword: {
      get() {
        return this.$store.state.userEdit["password"];
      },
      set(value) {
        this.$store.commit("updateUserPassword", value);
      }
    },
    userEmail: {
      get() {
        return this.$store.state.userEdit["email"];
      },
      set(value) {
        this.$store.commit("updateUserEmail", value);
      }
    },
    userRole: {
      get() {
        return this.$store.state.userEdit["role"];
      },
      set(value) {
        this.$store.commit("updateUserRole", value);
      }
    },
    userProfileImg: {
      get() {
        return this.$store.state.userEdit["profileImg"];
      },
      set(value) {
        this.$store.commit("updateUserProfileImg", value);
      }
    }
  },
  methods: {
    async addUser() {
      await this.selectUser({});
      this.confirmPassword = '';
      this.editName = true;
      this.editRole = true;
      this.editMail = true;
      this.editPassword = true;
      this.newUser = true;
    },
    selectUser(user) {
      this.$store.commit("setUserEdit", user);
      this.originalUser = Object.assign({}, user);
      this.editName = false;
      this.editRole = false;
      this.editMail = false;
      this.editPassword = false;
      this.newUser = false;

      this.userList.forEach(function(entry) {
        entry.clicked = false;
      });
      user.clicked = true;
    },
    deleteUser() {
      // console.log('deleteUser', this.selectedUser);
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteUser")
        .then(response => {
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("setUserEdit", this.userList[0]);
          this.originalUser = Object.assign({}, this.selectedUser);
          this.$store.commit("SET_DELETEUSERS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
          this.$notify({
            group: "foo",
            title: "Contacto eliminado",
            text: "El usuario se eliminó con éxito",
            type: "success",
            width: "340px"
          });
          this.getUserList();
        })
        .catch(error => {
          // console.log(error);
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("SET_DELETEUSERS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            title: "Ocurrió un error",
            text: "Por favor intenta de nuevo más tarde",
            type: "error",
            width: "340px"
          });
        });
    },
    editField(field) {
      //console.log('edit ',field);
      if (field == "name") {
        this.editName = true;
      } else if (field == "role") {
        this.editRole = true;
      } else if (field == "mail") {
        this.editMail = true;
      } else if (field == "password") {
        this.editPassword = true;
        this.selectedUser.password = "";
        this.confirmPassword = "";
      }
    },
    cancelEdit(field) {
      //console.log('edit ',field);
      this.$store.commit("setUserEdit", this.originalUser);
      if (field == "name") {
        this.editName = false;
      } else if (field == "role") {
        this.editRole = false;
      } else if (field == "mail") {
        this.editMail = false;
      } else if (field == "password") {
        this.editPassword = false;
      }
    },
    createUser() {
      if (
        this.selectedUser.name === "" ||
        typeof this.selectedUser.name === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un nombre"
        });
      } else if (
        this.selectedUser.role === "" ||
        typeof this.selectedUser.role === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha seleccionado un rol"
        });
      } else if (
        this.selectedUser.email === "" ||
        typeof this.selectedUser.email === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un correo"
        });
      }
      else {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("createUser")
          .then(response => {
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("setUserEdit", response.data.user);
            this.originalUser = Object.assign({}, this.selectedUser);

            this.editRole = false;
            this.editName = false;
            this.editMail = false;
            this.editPassword = false;
            this.newUser = false;
            this.$store.commit("SET_CREATEUSERS_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              title: "Contacto actualizado",
              text: "La información se guardó con éxito",
              type: "success",
              width: "340px"
            });
            this.getUserList();
          })
          .catch(error => {
            // console.log(error);
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("SET_CREATEUSERS_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              title: "ERROR",
              text: "Por favor verifica la información e intenta de nuevo",
              type: "error",
              width: "340px"
            });
          });
      }
    },
    async saveField(field) {
      // check for emty fields
      if (
        this.selectedUser._id === "" ||
        typeof this.selectedUser._id === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/users");
      } else if (
        this.selectedUser.name === "" ||
        typeof this.selectedUser.name === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un nombre"
        });
      } else if (
        this.selectedUser.role === "" ||
        typeof this.selectedUser.role === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha seleccionado un rol"
        });
      } else if (
        this.selectedUser.email === "" ||
        typeof this.selectedUser.email === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un correo"
        });
      } else {
        // return field to a no edition view
        if (field == "name") {
          this.editName = false;
        } else if (field == "role") {
          this.editRole = false;
        } else if (field == "mail") {
          this.editMail = false;
        } else if (field == "password") {
          this.editPassword = false;
        } else if (field == "createUser" && this.selectedUser.permission.createUser && this.selectedUser._id === this.currentUser._id) {
          if (!(await this.$refs.loseAccesModal.pop())) {
            this.selectedUser.permission.createUser = true;
          }
        } 
        // update originalUser
        this.originalUser = Object.assign({}, this.selectedUser);
        this.$store.commit("setIsLoadingState", true);
        // send request
        this.$store
          .dispatch("updateUser")
          .then(response => {
            this.$store.commit("SET_UPDATEUSERS_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              title: "Contacto actualizado",
              text: "La información se guardó con éxito",
              type: "success",
              width: "340px"
            });
            this.$store.commit("setIsLoadingState", false);
            this.getUserList();
          })
          .catch(error => {
            console.log(error.status);
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("SET_UPDATEUSERS_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              title: "ERROR",
              text: "Por favor verifica la información e intenta de nuevo",
              type: "error",
              width: "340px"
            });
          });
      }
    },
    updatePassword() {
      if (
        this.selectedUser._id === "" ||
        typeof this.selectedUser._id === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/users");
      } else if (
        this.selectedUser.password === "" ||
        typeof this.selectedUser.password === "undefined" ||
        this.selectedUser.password.length <= 6
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado una contraseña de al menos 6 caracteres"
        });
      } else if (this.confirmPassword !== this.selectedUser.password) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Las contraseñas no coinciden"
        });
      } else {
        // update originalUser
        this.originalUser = Object.assign({}, this.selectedUser);
        
        this.$store.commit("setIsLoadingState", true);
        // send request
        this.$store
          .dispatch("updatePassword")
          .then(response => {
            this.$store.commit("SET_UPDATEPASSWORD_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              title: "Contacto actualizado",
              text: "La contraseña se guardó con éxito",
              type: "success",
              width: "340px"
            });
            this.editPassword = false;
            this.$store.commit("setIsLoadingState", false);
            this.getUserList();
          })
          .catch(error => {
            // console.log(error);
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("SET_UPDATEPASSWORD_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              title: "ERROR",
              text: "Por favor verifica la contraseña e intenta de nuevo",
              type: "error",
              width: "340px"
            });
          });
      }
    },
    getUserList() {
      this.$store.dispatch("getUserList");
      if (this.$store.state.getUsersAsyncStatusCode == 200 && this.userList.length == 0) {
        this.addUser();
      }
    },
    pickFile () {
      this.$refs.image.click ();
    },
    uploadUserProfileImg (e) {
      this.getBase64(e.target.files[0]).then(fileData => {
        let imageData = {
          id: this.currentUser["_id"],
          file: fileData
        };
        this.$store.dispatch("uploadUserProfileImg", imageData)
      })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    deleteFoto() {
      let imageData = {
        id: this.currentUser["_id"],
        file: require("@/assets/upload-icon.png")
      };
      this.$store.dispatch("uploadUserProfileImg", imageData)
    }
  },
  mounted() {
    this.selectUser(this.currentUser);
    this.getUserList();
  }
};
</script>
<style src="./adminaccess.scss"  lang="scss" scoped >
</style>
